import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ButtonCode = styled.button`
  position: relative;
  background: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.primaryColorLight};
  font-weight: 600;
  font-size: 1.171vw;
  border: none;
  box-shadow: 0px 4px 18px ${({ theme }) => theme.shadows.medium};
  border-radius: 5px;
  width: 90%;
  height: 45px;
  min-height: 15px;
  margin-left: 5%;
  min-width: 108px;
  @media (max-width: 768px) {
    width: 70%;
    font-size: 12px;
    height: 30px;
  }
`;
export const ContentShowQR = styled.div`
  width: 100%;
  height: 3em;
  margin: 20px auto;
  font-size: 12px;
  display: -webkit-box;
  justify-content: center;
  span {
    color: blue;
    text-decoration: underline;
    cursor: pointer;
  }
  p {
    width: 46%;
    max-width: 270px;
  }
`;
export const TextVerificationCode = styled.p`
  margin: 0 auto;
  font-size: 1.025vw;
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

export const TitleVerificationCode = styled.label`
  margin: 0 auto;
  line-height: 150%;
  font-size: 1rem;
  font-weight: bold;
  margin-left: 5%;
  margin-top: 15px;
  @media (max-width: 768px) {
    font-size: 14px;
  }
`;
export const QrImg = styled.img`
  display: block;
  margin: 0 auto;
  width: 50%;
  height: auto;
`;
export const ContentManualTwoFactor = styled.div`
  width: 100%;
  font-size: 12px;
  display: flex;
  justify-content: center;
  span {
    color: blue;
    text-decoration: underline;
    cursor: pointer;
  }
  p {
    max-width: 270px;
    text-align: center;
  }
`;
export const TextInformationCode = styled.p`
  margin: 1 auto;
`;
